<template>
  <div class="user-citation">
    <Citation @authComplete="authComplete" :type="certType"/>

    <p class="footer-text">
      코리아크레딧뷰로에서 인증 받은 본인인증을 사용하고 있습니다.
      <span>본인인증 실패시 코리아크레딧뷰로 고객센터 02-708-100로 문의하세요</span>
    </p>
  </div>
</template>

<script>
import Citation from '@/components/Common/Citation.vue';

export default {
  name: 'JoinUserCitation',
  components: {Citation},
  data() {
    return {
      certType: 'signup',
    }
  },
  mounted () {
  },
  methods: {
    authComplete(certType, certInfo) {
      const certData = {
        type: certType,
        info: certInfo
      }
      this.$store.commit('setCert', certData);

      this.$router.push({name: 'form'});
    }
  }
}
</script>
